var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn-tiny",attrs:{"href":_vm.rowData.meta.url + '?as=' + _vm.rowData.title}},[_c('i',{staticClass:"icon ion-md-download"})])])}
var staticRenderFns = []

export { render, staticRenderFns }